module.exports = __webpack_public_path__ + "img/comparison.a123abec.svg";